/**
* ログイン管理
*/

import axios from '@/plugins/axios';
import router from '@/router';
import cf from '@/mixins/commonFunctions';

// 閲覧にログインが必要のページ名（配下含め）
const requiredLoginPageNames = [
  // 'admin',
  'account',
  'edit',
];


const actions = {
  /** state.isLoginの変更 */
  changeLoginStatus({ commit }, bool) {
    commit('changeLoginStatus', bool);
  },


  /** ログインしているかのチェック */
  check({ commit, dispatch, state }) {
    const ls = cf.getLocalStorage('times');
    // 現在の環境チェック
    dispatch('helper/checkEnv', null, { root: true });

    const currentPath = router.options.history.location;

    // localStorageが存在しない（未サインナップ）
    if (!ls || !ls.jwt) {
      commit('changeCheckedStatus', true);
      dispatch('user/setUserData', { hasntJWT: true }, { root: true });

      let isRedirect = false; // 編集後にtrueに戻す
      requiredLoginPageNames.some((pageName) => {
        if (currentPath.includes(pageName)) { isRedirect = true; return true; }
        return false;
      });

      // ログインページへリダイレクト
      if (isRedirect) {
        alert('本ページを閲覧するにはログインしている必要があります。\nログインページへリダイレクトします。');
        const current = router.options.history;
        const ref = { path: current.location };
        // ログイン後に元いたページへ戻すためpathとqueryを保持しておく
        cf.saveLocalStorage({ loginRef: JSON.stringify(ref) }, 'times');
        dispatch('redirect2Login');
      }

      return;
    }

    // ログインstateがなく、かつJWTがあれば認証APIを叩く
    if (!state.isLogin && ls.jwt) {
      dispatch('authCheck', {
        type: 'check',
        jwt: ls.jwt,
      });
    }
  },


  /**
   * ログインページのsubmit押下
   * API通信してIDとPASSをpost
   * 認証に成功したらJWT(token)をlocalStorageへ保存
   * @param obj data
   *   email:    str
   *   password: str
   */
  submit({ commit, dispatch }, data) {
    axios({
      method: 'post',
      url: '/v1/user/login',
      data,
    })
      .then((response) => {
        const res = response.data;
        if (res && res.token) {
          // tokenをlocalStorageに保存
          cf.saveLocalStorage({
            jwt: res.token,
            supportType: 'login',
          }, 'times');

          // 取得したtokenを元にログインチェック
          dispatch('authCheck', {
            type: 'login',
            isRegist: data.isRegist,
            jwt: res.token,
          });
        }
      })
      .catch((error) => {
        dispatch('loginFailed');
        if (error.response) {
          const errRes = error.response.data;
          const mailaddress = data.email;
          console.log(errRes);
          // ログイン失敗時にエラー内容を表示 アカウントなし：1 パスワード違い：2
          if (errRes.detail === `E_USER_NOT_FOUND: Cannot find user with email as ${mailaddress}`) {
            commit('changeLoginErrorStatus', 1);
          } else if (errRes.detail === 'E_PASSWORD_MISMATCH: Cannot verify user password') {
            commit('changeLoginErrorStatus', 2);
          }
          if (errRes.isBanned) {
            commit('changeBannedStatus', { isBanned: errRes.isBanned, unbannedTime: errRes.unbannedTime });
          } else if (errRes.failedStatus) {
            commit('changeBannedStatus', { isBanned: errRes.failedStatus.isBanned, unbannedTime: errRes.failedStatus.unbannedTime });
          } else {
            commit('changeBannedStatus', { isBanned: false, unbannedTime: null });
          }
        } else console.log(error);
      });
  },


  /**
   * auth情報を使ってログインチェックし
   * 取得したユーザーデータをstateへ格納
   * @param obj data
   *   jwt: obj
   *   type: 'check' || 'login'
   * logincheckではlocalstorageから
   * loginsubmitでは取得したjwtをdataに格納して渡す
   */
  authCheck({ commit, dispatch }, data) {
    const ls = cf.getLocalStorage('times');
    /** jwtからauthorization生成 */
    const Authorization = `${data.jwt.type} ${data.jwt.token}`;
    axios({
      method: 'GET',
      url: '/v1/user/loginCheck',
      headers: { Authorization },
    })
      .then((response) => {
        // user.flagが1以外はログイン無効
        const res = response.data.data;
        if (!res || res.flag !== 1) {
          // ログイン時には失敗の挙動
          if (data.type === 'login') dispatch('loginFailed');
          // localStorageのjwtを削除
          cf.deleteLocalStorage('times', 'jwt');
          commit('changeLoginStatus', false);
          return;
        }

        // authcheck後にstateを更新
        commit('changeLoginStatus', true);
        // ユーザー情報をstate.userにセット（user/index.js）
        dispatch('user/setUserData', res, { root: true });
        // システムマスターの判別
        dispatch('helper/checkSystemMaster', null, { root: true });
        // ログイン制限state解除
        commit('changeBannedStatus', { isBanned: false, unbannedTime: null });
        // ユーザーの支払い方法データ
        if (res.customer) {
          dispatch('user/subscribe/getCustomer', res, { root: true });
          // dispatch('user/subscriptions/getSubscriptions', res, { root: true });
        }
        // デバイスの確認
        dispatch('checkDevice', res);
        // 氏名登録の確認
        dispatch('checkUsername', res);

        // ログイン時
        if (data.type === 'login') {
          // リファラの有無でリダイレクト先が変わる
          if (ls && ls.loginRef) {
            const ref = JSON.parse(ls.loginRef);
            if (res.role && res.role.role === 7 && ref.path.includes('subscription')) {
              router.push({ path: '/' });
            } else {
              const pushParams = { ...ref };
              if (ls.query) {
                pushParams.query = ls.query;
              }
              router.push(pushParams);
            }
          } else {
            // TODO: ログイン前のページへリダイレクト

            router.push({ path: '/' });
          }
        }
      })
      .catch((error) => {
        console.log('ログイン認証エラー');
        if (error.response) console.log(error.response.data);
        else console.log(error);
        // ログイン画面へリダイレクトするかのフラグ
        let isRedirect2Login = true;
        if (data.type === 'check') {
          // ログインチェック時
          const status = error.response.status;
          if (status === 401) { // 期限切れ
            // ログインチェックが実行されたURL
            const originURL = location.href;
            // URLに指定ページ名が含まれていればフラグ有効化
            requiredLoginPageNames.some((pageName) => {
              if (originURL.includes(pageName)) {
                isRedirect2Login = false;
                return true;
              }
              return false;
            });

            if (isRedirect2Login) { // ログイン画面へリダイレクト
              alert('ログイン有効期限が切れています。\nログイン画面へリダイレクトします');
              const current = router.options.history;
              const ref = { path: current.location };
              // ログイン後に元いたページへ戻すためpathとqueryを保持しておく
              cf.saveLocalStorage({ loginRef: JSON.stringify(ref) }, 'times');
              dispatch('redirect2Login');
            } else { // 非ログインとしてログインページへリダイレクト
              dispatch('redirect2Login');
              cf.deleteLocalStorage('times', 'loginRef');
            }

            // localStorageのjwtを削除
            cf.deleteLocalStorage('times', 'jwt');
          } else if (status === 403) {
            // DBとの接続に失敗
            alert('データの取得に失敗しました。リロードをお試しください');
          }
        } else if (data.type === 'login') {
          // ログイン直後（取得直後のjwtなので論理的には失敗する事ないはず）
          // （user.flagが1以外の場合はこちらに入る）
          if (data.jwt && !error.response) {
            // ユーザのflagが1以外の場合
            dispatch('loginFailed');
            commit('changeLoginStatus', false);
          } else {
            alert('ログインで問題が発生しました\nお手数ですが管理者へお知らせください');
          }
          // localStorageのjwtを削除
          cf.deleteLocalStorage('times', 'jwt');
        }
      })
      .finally(() => {
        commit('changeCheckedStatus', true);
      });
  },

  /** 閲覧デバイスの確認 */
  checkDevice({ commit, dispatch }, data) {
    const userData = {
      user_id: data.id,
      userAgent: navigator.userAgent,
    };
    axios({
      method: 'POST',
      url: '/v1/user/check/device',
      data: userData,
    })
      .then((response) => {
        const res = response.data;
        // すでに登録済または新しく登録した場合
        if (res.exists || res.registed) {
          commit('changeDeviceStatus', true);
          dispatch('user/update', res, { root: true });
        } else {
          alert('閲覧デバイス数が上限に達しています。アカウントページより閲覧可能デバイスを設定してください。');
          commit('changeDeviceStatus', false);
          router.push('/account/');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  /** 氏名登録の必須化 */
  checkUsername({ dispatch }, data) {
    if (!data.last_name || !data.first_name) {
      const args = {
        modalName: 'regist-username',
      };
      dispatch('modal/contents/showModal', args, { root: true });
    }
  },

  /** ログイン失敗 */
  loginFailed({ commit }) {
    commit('changeVibrationStatus', true);
    setTimeout(() => { commit('changeVibrationStatus', false); }, 500);
  },


  /** 有効期限切れ時のログイン画面リダイレクト */
  redirect2Login() {
    router.push({ path: '/login/' });
  },


  /** トップへリダイレクト */
  redirect2Top() {
    router.push({ path: '/' });
  },


  /** ログアウト */
  logout({ commit, dispatch }) {
    // localStorageの更新
    cf.deleteLocalStorage('times', 'jwt');
    cf.deleteLocalStorage('times', 'loginRef');
    cf.deleteLocalStorage('times', 'lot');

    dispatch('helper/reset', null, { root: true });
    commit('changeLoginStatus', false);

    // ログインページへリダイレクト
    router.push({ path: '/login/' });

    // 全storeリセットのため強制リロード
    setTimeout(() => { router.go(router.currentRoute.path); }, 500);
  },
};

const mutations = {
  /** チェック済みステート */
  changeCheckedStatus(state, bool) {
    state.isChecked = bool;
  },

  /** ログインステート */
  changeLoginStatus(state, bool) {
    state.isLogin = bool;
  },

  /** デバイスステート */
  changeDeviceStatus(state, bool) {
    state.isValidDevice = bool;
    // アラートメッセージ設定
    const object = {
      message: '閲覧可能デバイス数が上限に達しているため有料記事および紙面が閲覧できません。アカウントページよりデバイスの設定を変更してください。',
      link: {
        label: 'アカウントページはこちら',
        to: '/account/',
      },
    };
    if (bool) state.alertMessages.device = null;
    else if (!bool) state.alertMessages.device = object;
  },

  /** ログイン失敗時のバイブフラグステート */
  changeVibrationStatus(state, bool) {
    state.vibration = bool;
  },

  /** ログイン制限時のフラグ・日時ステート */
  changeBannedStatus(state, { isBanned: bool, unbannedTime: datetime }) {
    state.isBanned = bool;
    state.unbannedTime = datetime;
  },

  /** ログイン失敗時のエラー内容ステート */
  changeLoginErrorStatus(state, number) {
    if (number === 0) {
      state.isFaild = 0;
    } else {
      state.isFaild = number;
    }
  },
};

const state = {
  isChecked: false,
  isLogin: false,
  isValidDevice: false,
  vibration: false,
  isBanned: false,
  unbannedTime: null,
  isFaild: 0,
  alertMessages: {
    device: null,
  },
};


export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
